import type { RouteAnswer, RouteCache, StoredRouteCache } from "./types";

// 2: lighting circuits are wired switch-first, so no answer drawn as a star may be reused.
const STORAGE_VERSION = 2;
const MAX_ENTRIES = 3000;

export const routeCacheStorageKey = (projectId: string, annotationKey: string): string =>
  `cables-routes:${projectId}:${annotationKey}`;

export const loadRouteCache = (key: string | null): RouteCache => {
  if (!key) return {};
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return {};
    const stored = JSON.parse(raw) as StoredRouteCache;
    if (stored.v !== STORAGE_VERSION || !Array.isArray(stored.entries)) return {};
    return Object.fromEntries(stored.entries);
  } catch {
    return {};
  }
};

// Oldest out first: insertion order is answer order, and an old answer is the least likely to be asked for again.
export const saveRouteCache = (key: string | null, cache: RouteCache): void => {
  if (!key) return;
  const entries: Array<[string, RouteAnswer]> = Object.entries(cache).slice(-MAX_ENTRIES);
  try {
    window.localStorage.setItem(key, JSON.stringify({ v: STORAGE_VERSION, entries }));
  } catch {
    // A full store costs the cache, never the edits; the answers are asked for again.
  }
};
